

if (!Number.prototype.roundTo) {
    Number.prototype.roundTo = function (decimalPlaces = 2) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(this * factor) / factor;
    };
}


if (!Number.prototype.ceilTo) {
    Number.prototype.ceilTo = function (decimalPlaces = 2) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.ceil(this * factor) / factor;
    };
}
